import { Text, TextProps } from '@chakra-ui/react';
import { toDisplayCurrency } from '../../../../utils/to-display-currency';

// NOTE: This component is used to display an amount in a consistent way
// If you pass the signed arguement to false on an amount that is negative, it will not still display the amount as negative

export type AmountProps = {
  amount: number;
  showPosSign?: boolean;
  amountTextProps?: TextProps;
  currencyTextProps?: TextProps;
} & TextProps;

export function Amount({
  amount,
  showPosSign = true,
  amountTextProps,
  currencyTextProps,
  ...rest
}: AmountProps): JSX.Element {
  const splitted = toDisplayCurrency(amount, 'EUR', showPosSign).split(
    /\s|&nbsp;/g
  );
  const amountString = splitted.slice(0, -1).join(' ');
  const currencyString = splitted.slice(-1);

  return (
    <Text data-testid="amount-text" {...rest}>
      <Text
        as="span"
        color={
          amount > 0 && showPosSign ? 'palette_success.50' : 'palette_gray.100'
        }
        {...amountTextProps}
      >
        {amountString}
      </Text>{' '}
      <Text
        data-testid="currency-text"
        as="span"
        color={
          amount > 0 && showPosSign ? 'palette_success.50' : 'palette_gray.100'
        }
        {...currencyTextProps}
      >
        {currencyString}
      </Text>
    </Text>
  );
}
